import { Loader } from "@octopus-energy/coral/atoms"
import {
    StyledPasswordStrengthBar,
    type StyledPasswordStrengthBarVariant,
} from "@octopus-energy/coral-design/recipes"

type GaugeProps = {
    ratio: number
    acceptanceRatio: number
}

function getPasswordScore({
    ratio,
    acceptanceRatio,
}: GaugeProps): StyledPasswordStrengthBarVariant["score"] {
    if (!acceptanceRatio) {
        return "0"
    }

    if (ratio >= acceptanceRatio) {
        return "4"
    }

    if (ratio >= acceptanceRatio * 0.75) {
        return "3"
    }

    if (ratio >= acceptanceRatio * 0.5) {
        return "2"
    }

    return "1"
}

export function Gauge({ ratio, acceptanceRatio }: GaugeProps) {
    const passwordStrengthBarClassName = StyledPasswordStrengthBar({
        score: getPasswordScore({ ratio, acceptanceRatio }),
    })

    return (
        <div className={passwordStrengthBarClassName}>
            <Loader
                type="linear"
                value={ratio * 100}
                variant="determinate"
            />
        </div>
    )
}
